import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { User } from '@shared/types';
import { catchError, map, Observable, throwError } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({ providedIn: 'root' })
export class UserService {
  private httpClient = inject(HttpClient);
  private utilsService = inject(UtilsService);

  public getMyHomeStats(): Observable<{
    customer_cases: number;
    transaction_cases: number;
    travel_rule_cases: number;
    total_cases: number;
    due_soon: number;
  }> {
    return this.httpClient.get<any>(
      this.utilsService.buildApiUrl('users/my-stats/')
    );
  }

  public getUsersList(): Observable<User[]> {
    return this.httpClient
      .get<{ results: User[] } | User[]>(
        this.utilsService.buildApiUrl('users/list/?page_size=1000&include_inactive=true')
      )
      .pipe(
        map((response) => (Array.isArray(response) ? response : (response.results ?? []))),
        catchError(() => {
          return throwError(() => new Error('get users list failed'));
        })
      );
  }
}
